import { basicEnum } from "./base";

export const ItemGroupUnitEnum = basicEnum([
    {
        label: "Satuan",
        value: "unit",
    },
    {
        label: "Sambungan",
        value: "continuous",
    },
    {
        label: "Batch",
        value: "batch",
    },
]);

export namespace ItemGroupUnitEnum {
    export type Labels = (typeof ItemGroupUnitEnum)["labels"][number];
    export type Values = (typeof ItemGroupUnitEnum)["values"][number];
}
